export enum ActionTypes {
  LOAD_ROUTE_INFO_REQUEST = "LOAD_ROUTE_INFO_REQUEST",
  LOAD_ROUTE_INFO_SUCCEEDED = "LOAD_ROUTE_INFO_SUCCEEDED",
  LOAD_ROUTE_INFO_FAILED = "LOAD_ROUTE_INFO_FAILED",

  SET_TRACKING_PARAMETERS = "SET_TRACKING_PARAMETERS",
  LOAD_TRACKING_REQUEST = "LOAD_TRACKING_REQUEST",
  LOAD_TRACKING_SUCCEEDED = "LOAD_TRACKING_SUCCEEDED",
  LOAD_TRACKING_FAILED = "LOAD_TRACKING_FAILED",

  LOAD_SAVED_ROUTES_REQUEST = "LOAD_SAVED_ROUTES_REQUEST",
  LOAD_SAVED_ROUTES_SUCCEEDED = "LOAD_SAVED_ROUTES_SUCCEEDED",
  LOAD_SAVED_ROUTES_FAILED = "LOAD_SAVED_ROUTES_FAILED",

  UPDATE_TRIP_FILTER_INTERVAL = "UPDATE_TRIP_FILTER_INTERVAL",
  CHANGED_PLANNED_ROUTE = "CHANGED_PLANNED_ROUTE",

  LOAD_MEDIA_EVENTS_REQUEST = "LOAD_MEDIA_EVENTS_REQUEST",
  LOAD_MEDIA_EVENTS_SUCCEEDED = "LOAD_MEDIA_EVENTS_SUCCEEDED",
  LOAD_MEDIA_EVENTS_FAILED = "LOAD_MEDIA_EVENTS_FAILED",

  SHOW_TRACKING_TAB = "SHOW_TRACKING_TAB",
  HIDE_TRACKING_TAB = "HIDE_TRACKING_TAB",

  SET_SELECTED_DEVICE_ID = "SET_SELECTED_DEVICE_ID",
}

export default ActionTypes;
